import React from 'react';
import Icon from './Icon';

/* Figma button: level1(primary), level2(outline-dark), level3(outline-light), level4(muted), level5(ghost), dark, outline-primary */
const levels = {
  level1: 'bg-orange-500 text-white hover:bg-orange-700',
  level2: 'bg-white border border-text-orange-500 text-mono-900 hover:bg-mono-50',
  level3: 'bg-white border border-mono-200 text-mono-900 hover:bg-mono-50',
  level4: 'bg-mono-100 text-mono-500 hover:bg-mono-200',
  level5: 'bg-transparent text-mono-500 hover:text-mono-900',
  dark: 'bg-mono-900 text-white hover:bg-mono-800',
  blue: 'bg-blue-500 text-white hover:bg-blue-700',
  red: 'bg-red-500 text-white hover:bg-red-700',
  'outline-red': 'bg-white border border-red-500 text-red-500 hover:bg-red-50',
  muted: 'bg-mono-100 text-mono-900 hover:bg-mono-200',
  inverse: 'bg-white text-orange-500 hover:bg-white/90',
  'outline-primary': 'bg-white border border-orange-500 text-orange-500 hover:bg-orange-50',
};

/* Figma size tokens: sm(36px), md(48px default) */
const sizes = {
  sm: 'h-8 px-3 text-2sm font-bold',
  md: 'h-12 px-5 text-sm font-bold',
};

/* Width variants: responsive patterns used across pages */
const widths = {
  auto: '',
  full: 'w-full',
  'fixed-100': 'w-[100px]',
  'fixed-140': 'w-[140px]',
  'responsive-130': 'w-[130px]',
  'responsive-lg-130': 'w-full lg:w-[130px]',
  'responsive-140': 'w-[100px] sm:w-[140px] shrink-0',
  'responsive-200': 'w-[160px] sm:w-[200px]',
};

export default function Button({
  children, level = 'level1', size = 'md', width = 'auto', fullWidth, icon, className = '', disabled, ...props
}) {
  return (
    <button
      disabled={disabled}
      className={`inline-flex items-center justify-center gap-2 rounded-lg transition-colors
        ${sizes[size] || sizes.md}
        ${levels[level] || levels.level1}
        ${fullWidth ? 'w-full' : widths[width] || ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}`}
      {...props}
    >
      {icon && <Icon name={icon} size={size === 'sm' ? 16 : 20} />}
      {children}
    </button>
  );
}
